import { graphql } from '@teachino/shared-infrastructure';

export const removeCourseTopicMutation = graphql(`
  mutation RemoveTopicInstances(
    $topicInstanceIds: [String!]!
    $forceDelete: Boolean
  ) {
    removeTopicInstances(
      removeTopicInstancesInput: {
        ids: $topicInstanceIds
        forceDelete: $forceDelete
      }
    ) {
      done
    }
  }
`);
